(()=>{
  if(window.HausPDPRefinement)return;
  window.HausPDPRefinement=true;
  const key='viewedProducts';
  function permitted(){try{return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed()===true;}catch{return false;}}
  function history(){if(!permitted())return [];try{const value=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(value)?value.filter(x=>/^\d+$/.test(String(x))).map(String).slice(0,4):[];}catch{return [];}}
  function remember(id){if(!permitted())return;try{localStorage.setItem(key,JSON.stringify([id,...history().filter(x=>x!==id)].slice(0,4)));}catch{}}
  function colors(value){return (value||'').toLowerCase().split(/[,/&]|\band\b/).map(x=>x.trim()).filter(Boolean);}
  function shared(a,b){return colors(a).some(x=>colors(b).includes(x));}
  function choose(cards,current,recent){
    const eligible=cards.filter(c=>c.dataset.productId!==current.id);
    const same=c=>c.dataset.family===current.family;
    const color=c=>shared(c.dataset.color,current.color);
    const sorted=eligible.slice().sort((a,b)=>Number(same(b))-Number(same(a))||Number(color(b))-Number(color(a)));
    const revisits=recent.map(id=>eligible.find(c=>c.dataset.productId===id)).filter(c=>c&&(same(c)||color(c))).slice(0,2);
    return [...new Set([...revisits,...sorted])].slice(0,5);
  }
  function discover(section){
    const pool=section.querySelector('[data-discovery-pool]'),visible=section.querySelector('[data-discovery-visible]');if(!pool||!visible)return;
    const current={id:section.dataset.currentId,family:section.dataset.currentFamily,color:section.dataset.currentColor};
    const selected=choose([...pool.content.querySelectorAll('[data-haus-discovery-card]')],current,history());
    visible.replaceChildren(...selected.map(card=>card.cloneNode(true)));
    if(window.Shopify?.theme?.role==='unpublished')visible.querySelectorAll('a[href]').forEach(a=>{
      const url=new URL(a.href,location.href);url.searchParams.set('preview_theme_id',String(Shopify.theme.id));a.href=url.href;
    });
    section.hidden=selected.length===0;
    remember(current.id);
    const room=section.closest('.shopify-section');
    const map=document.querySelector('.haus-pdp-map')?.closest('.shopify-section');
    const ceramic=document.querySelector('[id*="product_detail_section"]');
    const terrazzo=document.querySelector('.haus-terrazzo-fingerprint')?.closest('.shopify-section');
    if(room&&map&&room!==map&&room.nextElementSibling!==map)map.before(room);
    else if(room&&ceramic&&room!==ceramic)ceramic.after(room);
    else if(room&&terrazzo&&room!==terrazzo)terrazzo.before(room);
  }
  function init(){
    // Keep product exploration in the same unpublished theme during review.
    if(window.Shopify?.theme?.role==='unpublished'){
      document.querySelectorAll('a[href]').forEach(a=>{
        try{const url=new URL(a.href,location.href);
          if(url.origin===location.origin&&url.pathname.startsWith('/products/')){
            url.searchParams.set('preview_theme_id',String(Shopify.theme.id));a.href=url.href;
          }
        }catch{}
      });
    }
    const ceramic=document.querySelector('.product-information');
    const support=document.querySelector('[data-haus-ceramic-support]');
    if(ceramic&&support&&!ceramic.querySelector('[data-haus-quantity-guide]')){
      const sample=ceramic.querySelector('.tile-sample-section');
      if(sample){
        ceramic.classList.add('haus-pdp-refined');
        const area=document.createElement('div');area.className='haus-ceramic-support';area.append(support.content.cloneNode(true));sample.after(area);
        const note=sample.querySelector('.tile-sample-note');
        if(note){const d=document.createElement('details');d.className='haus-compact';const title=document.createElement('summary');title.textContent=/credit|guarantee/i.test(note.textContent)?'Sample guarantee':'About samples';d.append(title,note);area.querySelector('[data-haus-quantity-guide]').after(d);}
      }
    }
    const hero=document.querySelector('.haus-pdp-hero.haus-pdp-refined');
    if(hero){const note=hero.querySelector('.tile-sample-note'),slot=hero.querySelector('[data-haus-guarantee-slot]');if(note&&slot&&!slot.querySelector('details')){const d=document.createElement('details');d.className='haus-compact';const s=document.createElement('summary');s.textContent='Sample guarantee';d.append(s,note);slot.append(d);}}
    document.querySelectorAll('[data-haus-discovery]').forEach(discover);
  }
  function flip(card,open){
    card.classList.toggle('is-flip',open);
    const front=card.querySelector('.haus-card__front'),back=card.querySelector('[data-haus-card-back]'),button=card.querySelector('[data-haus-card-open]');
    front.inert=open;back.inert=!open;back.setAttribute('aria-hidden',String(!open));button.setAttribute('aria-expanded',String(open));
    (open?card.querySelector('[data-haus-card-close]'):button).focus({preventScroll:true});
  }
  document.addEventListener('click',e=>{
    const card=e.target.closest('[data-haus-discovery-card]');if(!card)return;
    e.stopImmediatePropagation();
    if(e.target.closest('a'))return;
    flip(card,!card.classList.contains('is-flip'));
  },true);
  document.addEventListener('keydown',e=>{
    const card=e.target.closest('[data-haus-discovery-card]');if(!card)return;e.stopImmediatePropagation();
    if(e.key==='Escape'){e.preventDefault();flip(card,false);}
  },true);
  document.addEventListener('visitorConsentCollected',()=>document.querySelectorAll('[data-haus-discovery]').forEach(discover));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures){window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)document.querySelectorAll('[data-haus-discovery]').forEach(discover);});}
  window.HausDiscovery={choose};
})();
